import { commissionService } from '../../helpers/services/commission.service'
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
  rates: { data: [] },
  records: { data: [], pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 } },
  summary: null,
  status: { list: true, save: true },
}

export const COMMISSION_MODULE = 'commission'

export const GET_ALL_COMMISSION_RATES = 'getAllCommissionRates'
export const CREATE_COMMISSION_RATE = 'createCommissionRate'
export const UPDATE_COMMISSION_RATE = 'updateCommissionRate'
export const DELETE_COMMISSION_RATE = 'deleteCommissionRate'
export const GET_ALL_COMMISSION_RECORDS = 'getAllCommissionRecords'
export const GET_COMMISSION_SUMMARY = 'getCommissionSummary'
export const BATCH_UPDATE_COMMISSION_STATUS = 'batchUpdateCommissionStatus'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const RATES_SUCCESS = 'ratesSuccess'
const RECORDS_SUCCESS = 'recordsSuccess'
const SUMMARY_SUCCESS = 'summarySuccess'

function mapRate(item) {
  return {
    id: item.id,
    agentCode: item.agent_code,
    itemCode: item.item_code,
    rateType: item.rate_type,
    rate: item.rate,
    notes: item.notes,
  }
}

function mapRecord(item) {
  return {
    id: item.id,
    agentCode: item.agent_code,
    docType: item.doc_type,
    docNo: item.doc_no,
    docDate: filtersHelper.getDateFormat(item.doc_date),
    periodMonth: item.period_month,
    amount: item.amount,
    commissionAmount: item.commission_amount,
    status: item.status,
  }
}

export const actions = {
  [GET_ALL_COMMISSION_RATES]({ commit }, { filter } = {}) {
    commit(REQUESTING, 'list')
    return commissionService.getAllRates(filter || {}).then((r) => {
      commit(RATES_SUCCESS, r); commit(SUCCESS)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [CREATE_COMMISSION_RATE]({ commit, dispatch }, { data }) {
    commit(REQUESTING, 'save')
    return commissionService.createRate(data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.createX', [i18n.t('module.commissionRate')]))
      commit(SUCCESS); dispatch(GET_ALL_COMMISSION_RATES, {}); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [UPDATE_COMMISSION_RATE]({ commit, dispatch }, { id, data }) {
    commit(REQUESTING, 'save')
    return commissionService.updateRate(id, data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.commissionRate')]))
      commit(SUCCESS); dispatch(GET_ALL_COMMISSION_RATES, {}); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [DELETE_COMMISSION_RATE]({ commit, dispatch }, { id }) {
    return commissionService.deleteRate(id).then((r) => {
      commit(SUCCESS); dispatch(GET_ALL_COMMISSION_RATES, {}); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [GET_ALL_COMMISSION_RECORDS]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    commissionService.getAllRecords(filter).then((r) => {
      commit(RECORDS_SUCCESS, r); commit(SUCCESS)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [GET_COMMISSION_SUMMARY]({ commit }, { filter } = {}) {
    return commissionService.getRecordSummary(filter || {}).then((r) => {
      commit(SUMMARY_SUCCESS, r); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [BATCH_UPDATE_COMMISSION_STATUS]({ commit, dispatch }, { data, filter }) {
    commit(REQUESTING, 'save')
    return commissionService.batchUpdateStatus(data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('label.status')]))
      commit(SUCCESS); if (filter) dispatch(GET_ALL_COMMISSION_RECORDS, { filter }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
}

export const mutations = {
  [RATES_SUCCESS](state, data) { state.rates.data = (data.data || []).map(mapRate) },
  [RECORDS_SUCCESS](state, data) {
    const items = data.data || []
    state.records.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.records.data = items.map(mapRecord)
  },
  [SUMMARY_SUCCESS](state, data) { state.summary = data.data || null },
  [FAILURE](state) { state.status = { list: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, save: true } },
}
